module.exports = __webpack_public_path__ + "img/1f5fb.6c796ae.svg";